import { faImage } from "@fortawesome/pro-solid-svg-icons"
import { IFormCreativeRow } from "form/model"
import { MediaDisplay } from "media/components/MediaDisplay"
import { mediaRPO } from "media/repository"
import React from "react"
import { Popup } from "ui/components/Popup"

interface ICreativeDetailsPopupProps {
  row: IFormCreativeRow
  onClose: () => any
}

const POPUP_DOM_ID: string = "creative-popup"

export const CreativeDetailsPopup = React.memo(
  ({ row, onClose }: ICreativeDetailsPopupProps): JSX.Element => (
    <Popup
      icon={faImage}
      id={POPUP_DOM_ID}
      title={row.name}
      displayCloseIcon
      onClose={() => onClose()}
      maxWidth="" // unset the default max-width
      sx={{
        "& .MuiDialogContent-root": {
          p: "1rem",
          pt: 0
        },
        "& .MuiPaper-root": {
          maxWidth: "100%"
        }
      }}>
      <MediaDisplay
        parentDomId={POPUP_DOM_ID}
        mediaUrl={mediaRPO.getMediaCreativeDownloadUrl(row.mediaId, row.creativeId)}
        type={row.type}
        isFullScreen
      />
    </Popup>
  )
)
